import type { MapDispatchToPropsFunction, MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { batchFormSelectAllToggledThunk, defaultBatchFormRequestedThunk } from 'state/batchForm/batchForm.thunks';
import { areAllBatchFormsSelectedByTabId, isNoFormSelectedByTabId } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { canAddNewFormInBatchTab } from 'state/workspaces/batch/tabContent/tabContent.selectors';

import type {
  BatchGridActionHeaderDispatchProps,
  BatchGridActionHeaderOwnProps,
  BatchGridActionHeaderStateProps,
} from './GridActionHeader.model';

export const mapStateToProps: MapStateToProps<
  BatchGridActionHeaderStateProps,
  BatchGridActionHeaderOwnProps,
  AppState
> = (state: AppState, ownProps: BatchGridActionHeaderOwnProps) => ({
  areAllFormsSelected: areAllBatchFormsSelectedByTabId(state, ownProps.tabId),
  isNoFormSelected: isNoFormSelectedByTabId(state, ownProps.tabId),
  canAddNewForm: canAddNewFormInBatchTab(state, ownProps.tabId),
});

export const mapDispatchToProps: MapDispatchToPropsFunction<
  BatchGridActionHeaderDispatchProps,
  BatchGridActionHeaderOwnProps
> = (dispatch: ThunkDispatch, ownProps: BatchGridActionHeaderOwnProps) => ({
  onNewFormAdded() {
    dispatch(
      defaultBatchFormRequestedThunk(
        ownProps.tabId,
        ownProps.productType,
        ownProps.productSubtype,
        ownProps.wrapper,
        ownProps.payoffType,
      ),
    );
  },
  onSelectAllToggled() {
    dispatch(batchFormSelectAllToggledThunk(ownProps.tabId));
  },
});

export const connectedBatchGridActionHeader = connect<
  BatchGridActionHeaderStateProps,
  BatchGridActionHeaderDispatchProps,
  BatchGridActionHeaderOwnProps,
  AppState
>(mapStateToProps, mapDispatchToProps);
